import { Routes } from '@angular/router';

export const deliveryRoutes: Routes = [
  {
    path: 'delivery',
    loadComponent: () => import('./delivery').then((x) => x.Delivery),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
  },
  {
    path: 'delivery/couriers',
    loadComponent: () => import('./couriers/couriers').then((x) => x.Couriers),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
  },
  {
    path: 'delivery/couriers/:courierId/history',
    loadComponent: () =>
      import('./courier-history/courier-history').then((x) => x.CourierHistory),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
  },
  {
    path: 'delivery/settings',
    loadComponent: () =>
      import('./delivery-settings/delivery-settings').then(
        (x) => x.DeliverySettings,
      ),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
    children: [
      {
        path: '',
        redirectTo: 'zones-tariffs',
        pathMatch: 'full',
      },
      {
        path: 'zones-tariffs',
        loadComponent: () =>
          import('./delivery-settings/delivery-zones-tariffs/delivery-zones-tariffs').then(
            (x) => x.DeliveryZonesTariffs,
          ),
      },
      {
        path: 'couriers-payouts',
        loadComponent: () =>
          import('./delivery-settings/delivery-couriers-payouts/delivery-couriers-payouts').then(
            (x) => x.DeliveryCouriersPayouts,
          ),
      },
      {
        path: 'integrations',
        loadComponent: () =>
          import('./delivery-settings/delivery-integrations/delivery-integrations').then(
            (x) => x.DeliveryIntegrations,
          ),
      },
      {
        path: 'website',
        loadComponent: () =>
          import('./delivery-settings/delivery-website/delivery-website').then(
            (x) => x.DeliveryWebsite,
          ),
      },
    ],
  },
  {
    path: 'delivery/reports',
    loadComponent: () =>
      import('./delivery-reports/delivery-reports').then(
        (x) => x.DeliveryReports,
      ),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
  },
  {
    path: 'delivery/telegram-broadcasts',
    loadComponent: () =>
      import('./telegram-broadcasts/telegram-broadcasts').then(
        (x) => x.TelegramBroadcasts,
      ),
    data: { privileges: ['delivery'], moduleName: 'delivery' },
  },
];
